import { Link } from "@tanstack/react-router"
import { Avatar } from "~/components/ui/avatar"
import { Card } from "~/components/ui/card"
import { RelativeTime } from "~/components/ui/relative-time"
import type { Notification } from "@apps/gwservice/types"
import { UnreadDot } from "~/components/unread-dot"

function Meta({ n }: { n: Notification }) {
  if (!n.group) return (
    <div className="flex items-center justify-end gap-s">
      <RelativeTime date={n.createdAt} className="text-xs text-muted-foreground" />
      {!n.read && <UnreadDot />}
    </div>
  )
  return (
    <div className="flex items-center gap-s">
      <Avatar url={n.group.avatar?.url} name={n.group.name} variant="group-sm" />
      <span className="font-medium truncate flex-1 min-w-0">{n.group.name}</span>
      <RelativeTime date={n.createdAt} className="text-muted-foreground shrink-0 text-sm" />
      {!n.read && <UnreadDot />}
    </div>
  )
}

const isExternal = (link: string) => /^https?:\/\//.test(link)

export function NotificationCard({ notification: n }: { notification: Notification }) {
  const content = (
    <Card className="flex flex-col gap-xs! py-s!">
      <Meta n={n} />
      {n.title && <div className="font-semibold line-clamp-3 hyphens-auto" lang="ru">{n.title}</div>}
      <div lang="ru" className="hyphens-auto whitespace-pre-line line-clamp-5 text-muted-foreground">{n.text}</div>
    </Card>
  )

  if (!n.link) return content
  return isExternal(n.link)
    ? <a href={n.link} target="_blank" rel="noopener noreferrer">{content}</a>
    : <Link to={n.link}>{content}</Link>
}
